import { Component, signal } from '@angular/core';
import { RawSequenceItemFormComponent } from "@app/components/forms/raw-sequence-item/form.component";
import { RawSequenceItemHelperService } from '@app/services/helpers/raw-sequence-item-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { RawSequenceItemCreate } from '@app/models/raw-sequence-item.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';

@Component({
    selector: 'app-raw-sequence-item-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        RawSequenceItemFormComponent,
        RouterModule,
        FontAwesomeModule,
    ]
})
export class RawSequenceItemCreatePage {
  public title = 'New Raw Sequence Item';
  formValid = signal(false);
  formValue = signal<RawSequenceItemCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private rawSequenceItemService: RawSequenceItemHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.rawSequenceItemService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/raw-sequence-items/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
